import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/fonts.css'
import './styles/tokens.css'
import './styles/base.css'
import App from './App.tsx'
import { UpdateBanner } from './components/UpdateBanner'
/*
  Importé pour son effet de bord, et il ne peut pas l'être plus tard.

  `beforeinstallprompt` est tiré par le navigateur AVANT que React ne soit
  monté : l'écouteur doit déjà être en place ici. Posé dans le Profil, au
  moment où l'écran s'affiche, l'événement serait passé depuis longtemps et
  le bouton « Installer » n'apparaîtrait jamais.
*/
import './lib/install'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
    {/*
      Hors de `App`, et volontairement.

      C'est ce composant qui enregistre le service worker — donc ce qui rend
      l'app démarrable hors ligne. Il doit être monté quoi qu'il arrive, or
      `App` sort par le haut dans trois cas : le panneau d'administration, le
      portail d'entrée, et le temps que le portefeuille se charge. Placé à
      l'intérieur, il aurait cessé d'exister sur le premier écran venu.
    */}
    <UpdateBanner />
  </StrictMode>,
)
